import { Navigate, useLocation } from 'react-router-dom'
import { usePublisherAuth } from '../context/PublisherAuthContext'

interface ProtectedPublisherRouteProps {
  children: React.ReactNode
}

export default function ProtectedPublisherRoute({ children }: ProtectedPublisherRouteProps) {
  const { isAuthenticated, loading } = usePublisherAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="mt-4 text-gray-500">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/publisher/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
